export * from './spinner.component';
export * from './spinner.service';



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/services/spinner/index.ts